<template>
    <div class="p-4 w-full max-w-2xl">
        <div class="text-lg">Opprett / rediger produkt</div>
        <UFormField label="Navn" required>
            <UInput
                id="name-input"
                ref="nameInput"
                v-model="internalProduct.name"
                class="w-full"
                placeholder="Navn"
                data-cy="product-name-input"
                autofocus
            />
        </UFormField>
        <UFormField label="Produktkode" required>
            <UInput
                v-model="internalProduct.code"
                class="w-full"
                data-cy="product-code-input"
            />
        </UFormField>
        <UFormField label="Beskrivelse">
            <UTextarea
                id="description-input"
                v-model="internalProduct.description"
                class="w-full"
                data-cy="product-description-input"
                placeholder="Beskrivelse"
            />
        </UFormField>
        <UFormField label="Utsalgspris eks MVA" required>
            <UInputNumber
                v-model="internalProduct.retailPrice"
                class="w-full"
                data-cy="product-price-input"
                :format-options="{
                    style: 'currency',
                    currency: 'NOK',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    currencyDisplay: 'code',
                    currencySign: 'accounting'
                }"
                :increment="false"
                :decrement="false"
            />
        </UFormField>
        <UFormField label="Inntektskonto" required>
            <income-account-picker v-model:account-no="internalProduct.accountNo" class="w-full" data-cy="product-income-account-input"/>
        </UFormField>
        <div class="flex justify-end gap-2 mt-4">
            <USwitch v-model="internalProduct.active" label="Aktiv" data-cy="product-is-active-input"/>
            <div class="grow"/>
            <UButton color="neutral" variant="outline" @click="cancel">Avbryt</UButton>
            <UButton
                data-cy="save-button"
                :disabled="!canSave"
                icon="i-ph-floppy-disk"
                @click="save"
            >
                Lagre
            </UButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue'
import {Product} from '@/products/product.types'
import {useProducts} from '@/products/product.service'
import IncomeAccountPicker from '@/bookkeeping-account/IncomeAccountPicker.vue'

const {getDefaultNewProduct, saveProduct, fetchProducts} = useProducts()

const props = defineProps({
    product: {
        type: Object as () => Product,
        required: false,
    }
})

const emit = defineEmits(['cancel', 'save'])

const internalProduct = ref<Product>(getDefaultNewProduct())

onMounted(() => {
    internalProduct.value = {...(props.product || getDefaultNewProduct())}
})

const cancel = () => {
    emit('cancel')
}

const save = async () => {
    const upsertedProduct = await saveProduct({
        ...internalProduct.value
    })
    emit('save', upsertedProduct)
    fetchProducts().then()
}

const setProduct = (product: Product) => {
    internalProduct.value = product
}

const canSave = computed(() => {
    return internalProduct.value.code !== '' && internalProduct.value.name !== ''
})

defineExpose({
    setProduct
})

</script>

<style scoped>

</style>